var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalyticsBb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.6 14A10.4 10.4 0 0 1 14 3.6h20A10.4 10.4 0 0 1 44.4 14v20A10.4 10.4 0 0 1 34 44.4H14A10.4 10.4 0 0 1 3.6 34V14ZM14 6.4A7.6 7.6 0 0 0 6.4 14v20c0 4.2 3.4 7.6 7.6 7.6h20c4.2 0 7.6-3.4 7.6-7.6V14c0-4.2-3.4-7.6-7.6-7.6H14Zm17.6 6.1a2.9 2.9 0 1 1 3.07 2.9l-2.81 5.9a2.9 2.9 0 1 1-4.71 3.38l-7.46.9a2.9 2.9 0 0 1-2.52 1.82l-2.81 5.9a2.9 2.9 0 1 1-2.53-1.2l2.81-5.9a2.9 2.9 0 0 1 4.71-3.38l7.46-.9a2.9 2.9 0 0 1 2.52-1.82l2.81-5.9a2.89 2.89 0 0 1-.54-1.7Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsBb);
export default __webpack_public_path__ + "static/media/analytics_bb.1c9393ce54ab77fc966cbde70f9f4f2e.svg";
export { ForwardRef as ReactComponent };